import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL.replace(/\/$/, '');

const AuthService = {
    login: async(creds) => {
        try{
            const response = await axios.post(`${API_BASE_URL}/auth/login`, creds, { withCredentials: true });
            return response;
        }catch(error){
            console.log("Error in login.", [error]);
            const errorMessage = error.response?.data?.message || "An unknown error occurred during login";
            throw new Error(errorMessage);
        }
    },
    requestPasswordReset: async(data) => {
        try{
            return await axios.post(`${API_BASE_URL}/auth/request-password-reset`, data, { withCredentials: true });
        }catch(error){
            console.log("Error in request password reset.", [error]);
            const errorMessage = error.response?.data?.message || "An unknown error occurred during password reset";
            throw new Error(errorMessage);
        }
    },

    resetPassword: async(id,data) => {
        try{
            return await axios.post(`${API_BASE_URL}/auth/reset-password`, data, { withCredentials: true });
        }catch(error){
            console.log("Error in reset password.", [error]);
            const errorMessage = error.response?.data?.message || "An unknown error occurred during password reset";
            throw new Error(errorMessage);
        }
    },
}
export default AuthService;